var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-center justify-center flex-nowrap" },
    [
      _c("b", { staticClass: "text-no-wrap" }, [
        _vm._v("Page " + _vm._s(_vm.page))
      ]),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c("v-btn", _vm._g({ attrs: { small: "", text: "" } }, on), [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.numbers) +
                        "/" +
                        _vm._s(_vm.pageSizes[_vm.pageSizeIndex]) +
                        "\n      "
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _c(
                "v-list-item-group",
                {
                  attrs: { mandatory: "" },
                  model: {
                    value: _vm.pageSizeIndex,
                    callback: function($$v) {
                      _vm.pageSizeIndex = $$v
                    },
                    expression: "pageSizeIndex"
                  }
                },
                _vm._l(_vm.pageSizes, function(item, index) {
                  return _c(
                    "v-list-item",
                    { key: index },
                    [_c("v-list-item-title", [_vm._v(_vm._s(item))])],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("custom-pagination", {
        attrs: {
          "disable-next": _vm.numbers < _vm.pageSizes[_vm.pageSizeIndex]
        },
        model: {
          value: _vm.page,
          callback: function($$v) {
            _vm.page = $$v
          },
          expression: "page"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }